import { Flex, Grid, GridItem, StyleProps, theme } from '@chakra-ui/react';
import * as React from 'react';
import { SurveyBanner } from '../../survey-banner/views';
import { Navbar } from '../Navbar/Navbar';

type UIProps = {
  columnRatio?: number;
} & StyleProps;

const UI: React.FC<React.PropsWithChildren<UIProps>> = ({ children, columnRatio = 50, ...props }) => {
  const maxWidth = 1500;
  const containerRef = React.useRef<HTMLDivElement>(null);
  const defaultLeftBg = theme.colors.white;
  const defaultRightBg = theme.colors.gray['50'];

  // make sure children have default bg colors
  const _children = React.Children.map(children, (child, i) => {
    const bgColor = (child as any).props.backgroundColor;
    const defaultColor = i === 0 ? defaultLeftBg : defaultRightBg;
    return React.cloneElement(child as React.ReactElement, {
      backgroundColor: bgColor ?? defaultColor,
    });
  });

  // extract bg color from children so we can set the bg of the container
  React.useEffect(() => {
    if (containerRef.current) {
      const columns = React.Children.toArray(_children);
      const leftColor = (columns[0] as any).props.backgroundColor;
      const rightColor = (columns[1] as any).props.backgroundColor;
      const bg = `linear-gradient(90deg, ${leftColor} ${columnRatio}%, ${rightColor} ${columnRatio}%)`;
      containerRef.current.style.background = bg;
    }
  }, []);

  return (
    <Flex height="100%" flexDirection="column" alignItems={'center'} ref={containerRef} w="100%">
      <Flex w="100%" borderBottomColor={'gray.100'} borderBottomWidth={1}>
        <Navbar />
      </Flex>
      <SurveyBanner />
      <Flex flexDirection={'column'} w="100%" flex="1">
        <Grid
          flex="1"
          w="100%"
          maxWidth={`${maxWidth}px`}
          marginX="auto"
          templateColumns={['1fr', '1fr', '1fr', `${columnRatio}% auto`]}
          templateRows={['max-content', 'max-content', 'max-content', 'auto']}
          {...props}>
          {_children}
        </Grid>
      </Flex>
    </Flex>
  );
};

const Column: React.FC<React.PropsWithChildren<StyleProps>> = ({ children, ...props }) => (
  <GridItem
    display="flex"
    flexDirection="column"
    paddingY={props.paddingY ?? ['20px', '20px', '20px', '50px']}
    paddingX={props.paddingY ?? ['20px', '20px', '20px', '50px']}
    width="100%"
    position="relative"
    {...props}>
    {children}
  </GridItem>
);

export default {
  LeftColumn: Column,
  RightColumn: Column,
  UI,
};
